const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

export const publicService = {
	getHomeStats: async () => {
		const response = await fetch(`${API_URL}/api/public/home-stats`);

		if (!response.ok) {
			throw new Error("Failed to load home stats");
		}

		return response.json();
	},

	getFeaturedResources: async () => {
		const response = await fetch(`${API_URL}/api/public/featured-resources`);

		if (!response.ok) {
			throw new Error("Failed to load featured resources");
		}

		return response.json();
	},

	getResourceById: async (id) => {
		const response = await fetch(`${API_URL}/api/public/resources/${id}`);

		if (!response.ok) {
			throw new Error("Failed to load resource details");
		}

		return response.json();
	},

	getResourcesByIds: async (ids = []) => {
		const cleaned = (ids || [])
			.map(Number)
			.filter((id) => Number.isInteger(id));

		if (cleaned.length === 0) {
			return [];
		}

		const response = await fetch(
			`${API_URL}/api/public/resources-by-ids?ids=${cleaned.join(",")}`,
		);

		if (!response.ok) {
			throw new Error("Failed to load selected resources");
		}

		return response.json();
	},

	getResources: async (params = {}) => {
		const queryString = new URLSearchParams();
		if (params.search) queryString.append("search", params.search);
		if (params.role) queryString.append("role", params.role);
		if (params.category) queryString.append("category", params.category);
		if (params.sortBy) queryString.append("sortBy", params.sortBy);
		if (params.page) queryString.append("page", String(params.page));
		if (params.limit) queryString.append("limit", String(params.limit));

		const response = await fetch(
			`${API_URL}/api/public/resources?${queryString.toString()}`,
		);

		if (!response.ok) {
			throw new Error("Failed to load resources");
		}

		return response.json();
	},

	getRoles: async () => {
		const response = await fetch(`${API_URL}/api/public/roles`);

		if (!response.ok) {
			throw new Error("Failed to load roles");
		}

		return response.json();
	},

	getCategories: async () => {
		const response = await fetch(`${API_URL}/api/public/categories`);

		if (!response.ok) {
			throw new Error("Failed to load categories");
		}

		return response.json();
	},

	getSkillMatrix: async (params = {}) => {
		const queryString = new URLSearchParams();
		if (params.category) queryString.append("category", params.category);

		const response = await fetch(
			`${API_URL}/api/public/skill-matrix?${queryString.toString()}`,
		);

		if (!response.ok) {
			throw new Error("Failed to load skill matrix");
		}

		return response.json();
	},

	submitContact: async (payload) => {
		const response = await fetch(`${API_URL}/api/public/contact`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			throw new Error("Failed to submit contact form");
		}

		return response.json();
	},

	submitInquiry: async (payload) => {
		const response = await fetch(`${API_URL}/api/public/inquiry`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			throw new Error("Failed to submit inquiry");
		}

		return response.json();
	},

	validateAndSendCode: async (payload) => {
		const response = await fetch(
			`${API_URL}/api/public/inquiries/validate-and-send-code`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(payload),
			},
		);

		if (!response.ok) {
			const error = await response.json().catch(() => ({}));
			throw new Error(error.message || "Failed to validate and send code");
		}

		return response.json();
	},

	verifyInquiryCode: async (submissionId, code) => {
		const response = await fetch(
			`${API_URL}/api/public/inquiries/verify-code`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ submissionId, code }),
			},
		);

		if (!response.ok) {
			const error = await response.json().catch(() => ({}));
			throw new Error(error.message || "Failed to verify code");
		}

		return response.json();
	},
};
